module.exports = __webpack_public_path__ + "static/benkyou-logo-0dc11e2ded3158a29921eb4291796b79.png";